import { Search, UserCheck, Users, Rocket } from 'lucide-react';

const steps = [
  {
    icon: Search,
    step: '01',
    title: 'Discovery Call',
    description:
      'We listen carefully to understand your business, security challenges, and ambitions.',
  },
  {
    icon: UserCheck,
    step: '02',
    title: 'Understand Your Goals',
    description: 'We dig deeper to understand what success looks like for your specific situation.',
  },
  {
    icon: Users,
    step: '03',
    title: 'CISO Matching',
    description:
      'We introduce you to the right CISO from our network whose experience aligns with your needs.',
  },
  {
    icon: Rocket,
    step: '04',
    title: 'Ongoing Leadership',
    description:
      'Your CISO provides continuous strategic security guidance, scaled to your pace and budget.',
  },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="relative py-24 gradient-navy noise-bg overflow-hidden">
      <div className="container-custom relative z-10">
        <div className="text-center mb-16 animate-fade-up">
          <span className="text-xs font-medium text-teal tracking-[0.2em] uppercase">
            How We Work
          </span>
          <div className="mx-auto mt-4 mb-5 h-px w-12 bg-teal/40" />
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary-foreground tracking-tight mb-4">
            Finding Your CISO - Here's How We Work
          </h2>
          <p className="text-primary-foreground/60 max-w-3xl mx-auto text-lg">
            Our refined approach ensures seamless integration, trusted relationships, and outcomes
            that give you confidence from day one.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8">
          {steps.map((step, i) => (
            <div
              key={step.step}
              className="relative text-center group animate-fade-up"
              style={{ animationDelay: `${i * 0.15}s` }}
            >
              {/* Connector line */}
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-16 left-[60%] w-[80%] h-px bg-gradient-to-r from-teal/30 to-transparent" />
              )}

              <div className="text-6xl font-heading font-bold text-teal/25 mb-4 group-hover:text-teal/40 transition-colors duration-500">
                {step.step}
              </div>
              <div className="h-14 w-14 mx-auto rounded-full border-2 border-teal/30 flex items-center justify-center mb-5 group-hover:border-teal group-hover:bg-teal/10 transition-all duration-300 group-hover:scale-110">
                <step.icon className="h-6 w-6 text-teal transition-transform duration-300 group-hover:scale-110" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-primary-foreground mb-2 group-hover:text-teal transition-colors duration-300">
                {step.title}
              </h3>
              <p className="text-primary-foreground/50 text-sm leading-relaxed group-hover:text-primary-foreground/70 transition-colors duration-300">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
